var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{ref:"container",attrs:{"width":"800","height":"800"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }